import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-foreground-100/50 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-foreground-400">
          &copy; {new Date().getFullYear()} {t('common.siteName')}
        </div>
        <div className="flex items-center gap-6 text-sm text-foreground-400">
          <Link to="/about" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
            {t('nav.about')}
          </Link>
          <Link to="/journey" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
            {t('nav.journey')}
          </Link>
          <Link to="/contact" className="hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap">
            {t('nav.contact')}
          </Link>
        </div>
      </div>
    </footer>
  );
}